export const UPLOAD_FILE_ADMIN_PREFIX = 'uploaded-file-admin-'
export const MANUAL_FILE_ADMIN_PREFIX = 'manual-file-admin-'

export const REUPLOAD_ORIGINAL_FILES = 'ReUpload-Original-Files'
export const REUPLOAD_DELIVERABLE_FILES = 'ReUpload-Deliverable-Files'
export const REUPLOAD_TIME = 'ReUpload-Time'
export const REUPLOAD_BY = 'ReUpload-By'

export const MANUAL_UPLOAD_FILES = 'Manual-Uploaded-Files'
export const MANUAL_UPLOAD_TIME = 'Manual-Upload-Time'
export const MANUAL_UPLOAD_BY = 'Manual-Uploaded-By'

export const ADMIN_UPLOAD_FILES = 'Admin-Uploaded-Files'
export const ADMIN_UPLOAD_TIME = 'Admin-Upload-Time'
export const ADMIN_UPLOAD_BY = 'Admin-Uploaded-By'

export const CLIENT_ROS_FILE = 'Client-ROS-File'
